import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-offer-priority',
  templateUrl: './admin-offer-priority.component.html',
  styleUrls: ['./admin-offer-priority.component.scss']
})
export class AdminOfferPriorityComponent extends SubscriptionBaseComponent implements OnInit {

  title: string;
  searchForm: UntypedFormGroup;
  valueInput: string;

  offersNoPriorityFiltered: FullOffer[] = [];
  offersNoPriority: FullOffer[] = [];
  offersPriority: FullOffer[] = [];
  offers: FullOffer[];
  offerPreview: FullOffer;
  userConnected: any;
  imgDefault: string;
  dragOffer: number;
  clubCode: string;
  showDetailsClubPriority: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private faIconService: FaiconService,

  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  goBack(): void {
    !this.showDetailsClubPriority ?
      this.router.navigate(['/admin']) :
      (this.dataService.showDetailsClubPriority$.next(!this.showDetailsClubPriority),
        this.dataService.titleOfferPriority$.next('Gestion des offres prioritaires'),
        this.router.navigate(['/admin/offer-priority']));
  }

  applyFilter(valueInput: string): void {
    this.dataService.valueFilterOfferPriority$.next(valueInput.toLocaleLowerCase());
    this.valueInput = valueInput.toLocaleLowerCase();
  }

  resetSearch(): void {
    this.dataService.valueFilterOfferPriority$.next('');
    this.f.keyword.setValue('');
  }

  getPlacehokder(): string {
    let placeholder: string = null;
    if (this.userConnected.role === 'club') {
      placeholder = 'Chercher une offre...';
    } else if (this.userConnected.role === 'admin') {
      placeholder = this.showDetailsClubPriority ? 'Chercher une offre...' : 'Chercher un club...';
    }
    return placeholder;
  }

  private initComponent() {
    this.dataService.showDetailsClubPriority$.next(false);
    this.userConnected = this.authService.getDecodedToken();

    const clubCode = {
      club: this.userConnected.club_code,
      admin: null
    };

    this.clubCode = clubCode[this.userConnected.role];
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.titleOfferPriority$.subscribe({
          next: title => {
            this.title = title;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.showDetailsClubPriority$.subscribe({
          next: showDetailsClubPriority => {
            this.showDetailsClubPriority = showDetailsClubPriority;
            this.cdr.detectChanges();
          }
        })
      );
  }

}
